export default __webpack_public_path__ + "static/media/ic_arb_40.abae01ba.svg";